import { render } from "./CadastrarRespostaCrm.vue?vue&type=template&id=f52a0df2"
import script from "./CadastrarRespostaCrm.vue?vue&type=script&lang=js"
export * from "./CadastrarRespostaCrm.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__